import { DEFAULT_THUMBNAIL_WIDTH } from '@anm/constants/videoLandings';
import { FC } from 'react';

import { Placeholder, PlayIcon, Thumbnail, ThumbWrapper } from './Wrapper';

export type ThumbnailButton = {
  color: string;
  enabled: boolean;
};

export type ContextVariant = 'email' | 'inline' | 'highlight' | 'thumbnail' | 'text';

type PreviewInContextProps = {
  src?: string;
  button?: ThumbnailButton;
  buttonUrl?: string;
  isVertical?: boolean;
  contextVariant?: ContextVariant;
  showPlaceholder?: boolean;
  placeholderHeight?: number;
  showContextOnMobiles?: boolean;
};

const PreviewInContext: FC<PreviewInContextProps> = ({
  src,
  button,
  children,
  buttonUrl,
  isVertical = false,
  showPlaceholder = false,
  contextVariant = 'email',
  showContextOnMobiles = true,
  placeholderHeight
}) => {
  const canShowThumbnail = !!src && !children;
  const canShowPlaceholder = showPlaceholder && placeholderHeight && !canShowThumbnail;
  const canRender = !!(canShowPlaceholder || canShowThumbnail || children);
  const canShowPlayButton = button && button.enabled && (canShowPlaceholder || canShowThumbnail);

  if (!canRender) return null;

  return (
    <ThumbWrapper variant={contextVariant} {...{ showContextOnMobiles }}>
      {canShowPlaceholder && (
        <Placeholder
          width={DEFAULT_THUMBNAIL_WIDTH}
          height={placeholderHeight!}
          {...{ isVertical, showContextOnMobiles }}
        />
      )}
      {canShowThumbnail && <Thumbnail src={src!} {...{ isVertical }} />}
      {children}
      {canShowPlayButton && (
        <a href={buttonUrl} target="_blank">
          <PlayIcon color={button!.color} />
        </a>
      )}
    </ThumbWrapper>
  );
};

export default PreviewInContext;
